// extracted by mini-css-extract-plugin
export var dropdownContainer = "_o8-0";
export var leftAlign = "_o8-4";
export var listItem = "_o8-2";
export var listItemWrapper = "_o8-1";
export var operationText = "_o8-3";